import * as React from 'react';

import { IStock } from '@notino/shared/definitions/custom-definitions';
import { CatalogVariantFragmentFragment } from '@notino/shared/definitions/types';

import { Tags } from '@components/Tags';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';
import { useTrackingContext } from '@context/tracking/TrackingContext';

import { OriginalPrice } from './OriginalPrice';
import { TagDiscountFlexRow } from './styled';
import { trackTagClick } from './tracking';

interface ITagDiscountProps {
  variant: CatalogVariantFragmentFragment;
}

export const TagDiscount = ({ variant }: ITagDiscountProps) => {
  const { getTimeFromInit } = useTrackingContext();
  const { pd_new_action_label_design } = useFeatureFlags();
  const { currentVariant } = useProductDetailContext();

  const isEligibleAction =
    currentVariant?.recentMinPrice?.isActionEligible &&
    currentVariant?.attributes?.Action &&
    pd_new_action_label_design;

  return (
    <TagDiscountFlexRow>
      <Tags
        onClick={(attr) => trackTagClick(attr, getTimeFromInit())}
        multiple={true}
        attributes={variant.attributes}
        stockAvailability={variant.stockAvailability.code}
        nowrapLg={true}
      />

      {variant.stockAvailability.code !== IStock.outOfStock &&
        !isEligibleAction && <OriginalPrice variant={variant} />}
    </TagDiscountFlexRow>
  );
};
